
  import { defineComponent } from 'vue';
  import { Icon } from '@/ui/components/icon/Icon';

  interface ChooseMethodActionProps {
    icon: string;
    title: string;
    subtitle: string;
  }

  export default defineComponent<ChooseMethodActionProps>({
    components: { Icon },
    props: ['icon', 'title', 'subtitle'],
    emits: ['click'],
  });
